import { BrokerageStatusCodeEvent } from "../BrokerageStatusCodeEvent";
import { Button, DataHeader, DataSource, Label, Layout, Panel, Switch, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutBrokerageStatusCode extends Layout {
    buttonClearEvenColor: Button;
    buttonColorPicker: Button;
    buttonOpenClassic: Button;
    labelOrderPlanningColor: Label;
    layoutBrokerageStatusCodeEvent: BrokerageStatusCodeEvent;
    panelColorDisplay: Panel;
    panelColorSelector: Panel;
    panelDataHeader: DataHeader;
    panelStatusCode: Panel;
    sourceBrokerageStatus: DataSource;
    sourceBrokerageStatusEvent: DataSource;
    switchCarrierCallin: Switch;
    switchDisplayWebPortal: Switch;
    switchIsActive: Switch;
    tabEquipment: Tab;
    tabGeneral: Tab;
    tabsetDriver: Tabset;
    textStatusID: Textbox;
    textboxDescr: Textbox;
    textboxHexPlanningColor: Textbox;
    textboxPlanningColor: Textbox;
}
